import {type ReactNode} from 'react'
import {KairosMark} from '@/components/kairos-mark'

const WIDTH_CLASSES = {
  sm: 'w-full max-w-sm',
  md: 'w-full max-w-md',
} as const

export function RegistroShell({
  eyebrow,
  width = 'sm',
  children,
}: {
  eyebrow?: string
  width?: 'sm' | 'md'
  children: ReactNode
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10 sm:py-12">
      <div className={WIDTH_CLASSES[width]}>
        <div className="surface surface-raised">
          <div className="surface-divider flex items-center gap-2 border-b border-dashed px-6 py-3.5">
            <KairosMark />
            <span className="font-heading text-base tracking-tight text-foreground">Kairos</span>
            {eyebrow && (
              <span className="ml-auto min-w-0 truncate font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">
                {eyebrow}
              </span>
            )}
          </div>
          <div className="p-6 sm:p-7">{children}</div>
        </div>
      </div>
    </div>
  )
}
